<template>
  <div class="repair-td-special-instruction">
    <h3 class="blue-text">{{L10n('special-instruction-td')}}</h3>
    <no-data :isNoData="instructions.length === 0">
      <el-form>
        <el-form-item class="material-style" v-for="(item, i) in instructions" :key="i">
          <el-input
            type="textarea"
            :value="item.remark"
            disabled/>
        </el-form-item>
      </el-form>
    </no-data>
  </div>
</template>

<script>

export default {
  name: 'SectionSpecialInstruction',
  components: {
    'no-data': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/NoData')
  },
  props: {
    instructions: { type: Array }
  }
}
</script>
<style lang="stylus">
  .repair-td-special-instruction{
    min-height 20rem
    .no-data-layer{
      &__no-data{
        min-height 10rem
      }
    }
  }
</style>
